<script setup>
  import FlowLogo from '@/shared/components/rebranding/FlowLogo/FlowLogo.vue'
  import { LoaderQC } from '@qicgroupdoha/qic-connect-ds'
</script>

<template>
  <div class="redirect-loader">
    <div
      class="redirect-loader__logo"
      :class="{ 'redirect-loader__logo--mobile': $qicConnect.isMobile }"
    >
      <FlowLogo color="var(--colorArabianBlue50)" />
    </div>
    <div class="redirect-loader__content">
      <div
        class="redirect-loader__en"
        :class="{
          'heading-1': !$qicConnect.isMobile,
          'heading-4': $qicConnect.isMobile,
        }"
      >
        Redirecting to policy page
      </div>
      <LoaderQC size="extraExtraLarge" color="var(--colorIcnSrfContrastLight)" />
      <div
        class="rtl"
        :class="{
          'heading-1': !$qicConnect.isMobile,
          'heading-4': $qicConnect.isMobile,
        }"
      >
        جاري تحميل صفحة الدفع
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .redirect-loader {
    background-color: var(--colorBgSrfAccentBrand);
    color: #fff;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .redirect-loader__logo {
    padding-block: var(--spacing-7);
    margin-top: var(--spacing-7);

    &.redirect-loader__logo--mobile {
      margin-top: 0;
      padding-block: var(--spacing-5);
    }
  }

  .redirect-loader__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-8);
    height: 100%;
  }

  .redirect-loader__en {
    width: 70%;
    text-align: center;
  }
</style>
